/**
 * Служебная компоненты для разработки и тестирования REST API к flowable
 */
import React from 'react';
import ApiUtils from './ApiUtils';


class Development extends React.Component {
  state = {
    processInstances: ["none"],  //Список процессов
  }

  componentDidMount() {
    this.load();
  }

  load() {
    ApiUtils.getProcessDefinitions()
      .then(result => {
        console.log("flowable/Development.js load()", result);
        this.setState({processInstances: result});
        return {concepts: data, loading: false};
      });
  }

  render() {
		console.log(this);
    const {processInstances} = this.state;
		return (
      <span>
        <div>Список процессов</div>
        {JSON.stringify(processInstances)}
      </span>
    )
  }
}

export default Development;